import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbItem {
  name: string;
  item: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-8 overflow-x-auto no-scrollbar">
      <ol className="flex items-center gap-2 whitespace-nowrap">
        <li>
          <Link 
            to="/" 
            className="flex items-center gap-1.5 text-xs font-bold text-slate-400 hover:text-teal-400 uppercase tracking-widest transition-colors"
          >
            <Home className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Portal Root</span>
          </Link>
        </li>
        
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <ChevronRight className="w-3.5 h-3.5 text-slate-700 flex-shrink-0" />
            {index === items.length - 1 ? (
              <span className="text-[10px] sm:text-xs font-bold text-teal-400 uppercase tracking-widest truncate max-w-[150px] sm:max-w-[300px]">
                {item.name}
              </span>
            ) : (
              <Link
                to={item.item}
                className="text-xs font-bold text-slate-400 hover:text-teal-400 uppercase tracking-widest transition-colors"
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
